import React from "react"
import { Container } from "react-bootstrap"
import { GatsbyImage } from "gatsby-plugin-image"
import { Box, IconButton, Modal } from "@mui/material"
import { Close } from "@mui/icons-material"

import * as styles from "./ImagePreview.module.scss"

const ImagePreview = ({ open, handleClose, image }) => {
  return (
    <Container>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <Box>
          <GatsbyImage
            className={styles.previewContainer}
            imgStyle={{ objectFit: "contain" }}
            image={image}
          />
          <IconButton onClick={handleClose} sx={{ float: "right" }}>
            <Close style={{ fill: "white" }} />
          </IconButton>
        </Box>
      </Modal>
    </Container>
  )
}

export default ImagePreview